/**
 * Re-export shim, implementation in `flow-core/flowValidation.js`.
 *
 * See `utils/componentUtils.js` for why the registry is bootstrapped here.
 */
import '../components/FlowBuilder/flow-components';
import {
  buildValidationMap as buildValidationMapImpl,
  validateScreenGraph as validateScreenGraphImpl,
} from '../flow-core/flowValidation';

export {
  VALIDATION_LEVELS,
  FLOW_JSON_VERSION,
  MAX_COMPONENTS_PER_SCREEN,
  forEachComponentDeep,
  forEachComponentInScreens,
  validateFlowStructure,
  validateScreen,
  validateFlow,
  validateForDeployment,
  validateBuilderScreens,
  validateScreenGraph,
  buildValidationMap,
} from '../flow-core/flowValidation';

/**
 * What the builders show: the per-component / per-screen map plus the flow-level findings
 * (reachability, routing rules) under `flowIssues`, with totals that count both. Both the canvas
 * and the assistant use this, so they count the same things; before, the map alone left out the
 * checks the save gate and WhatsApp enforce, and the canvas could say "No problems" about a flow
 * that would be refused.
 */
export const buildBuilderValidationMap = (screens, options = {}) => {
  const map = buildValidationMapImpl(screens, options);
  const flowIssues = validateScreenGraphImpl(screens || []);
  return {
    ...map,
    flowIssues,
    totals: {
      errorCount: map.totals.errorCount + flowIssues.errors.length,
      warningCount: map.totals.warningCount + flowIssues.warnings.length,
    },
  };
};
